export const colors = {
  primaryColor : "#00e1ff",
  secondaryColor : "#0f0f0f",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(107deg, rgba(0, 0, 0, 0.60) -2.13%, rgba(0, 0, 0, 0.60) 35.42%, rgba(0, 225, 255, 0.60) 77.97%, rgba(0, 225, 255, 0.60) 125.13%)",
darkColor:"#01c1da"
}